import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { Link as RouterLink } from "react-router-dom";
import {
  fn_endOrderSearch,
  fn_getDateTerm,
  fn_getDetailButtonView,
  fn_getSearchKey,
  fn_getSearchVal,
  fn_getSearchView,
  fn_initDetailButtonView,
  fn_setDateTerm,
  fn_setDetailButtonView,
  fn_setSearchKey,
  fn_setSearchVal,
  fn_setSearchView,
  fn_setBeforeDetailUpdate,
} from "../../function/FnBodyEndOrder";
import EndOrderPagingBottomView from "./sub/EndOrderPagingBottomView";
import EndOrderItemView from "./sub/EndOrderItemView";
import EndDatePicker from "./sub/EndDatePicker";
import StartDatePicker from "./sub/StartDatePicker";
import { analyticeEvent } from "utils/Utils";
import {
  orderChannelFilters,
  orderStatusFilters,
  orderTypeFilters,
  paymentMethodFilters,
} from "constants/order/orderConifg";
import Chip from "components/ui/Chip";

const Link = RouterLink as any;

const SettingEndOrderView = ({ rootStore }: { rootStore: any }) => {
  const { endOrderStore } = rootStore;

  useEffect(() => {
    fn_setDateTerm(rootStore, "today", true);
    fn_endOrderSearch(rootStore);
  }, []);

  return (
    <>
      <div className="article_order_history">
        <div
          className={fn_getSearchView(rootStore).detail_area_view ? "bg" : "hide"}
          onClick={() => {
            fn_setSearchView(rootStore, "detail_area_view", !fn_getSearchView(rootStore).detail_area_view);
            fn_setBeforeDetailUpdate(rootStore);
          }}
        ></div>
        <div
          className={fn_getSearchView(rootStore).key_area_view ? "bg" : "hide"}
          onClick={() => fn_setSearchView(rootStore, "key_area_view", !fn_getSearchView(rootStore).key_area_view)}
        ></div>
        <div className="section_order_history">
          <div className="wrap_search">
            <div className="box_date">
              <div className="tit"> • 조회기간</div>
              <label
                className="date"
                onClick={() =>
                  analyticeEvent("search", "searchDatePickerStart Button", rootStore.searchStore.getShopCd)
                }
              >
                <StartDatePicker rootStore={rootStore} />
                <span className="ico_date"></span>
              </label>
              <div className="txt_bar">-</div>
              <label
                className="date"
                onClick={() => analyticeEvent("search", "searchDatePickerEnd Button", rootStore.searchStore.getShopCd)}
              >
                <EndDatePicker rootStore={rootStore} />
                <span className="ico_date"></span>
              </label>
              <div className="selects">
                <label
                  onClick={event => {
                    event.preventDefault();
                    fn_setDateTerm(rootStore, "today", true);
                    fn_endOrderSearch(rootStore, "searchOldToday Button");
                  }}
                >
                  <input type="radio" name="date" readOnly={true} checked={fn_getDateTerm(rootStore).today} />
                  <span className="txt today">오늘</span>
                </label>
                <label
                  onClick={event => {
                    event.preventDefault();
                    fn_setDateTerm(rootStore, "three", true);
                    fn_endOrderSearch(rootStore, "searchOld3day Button");
                  }}
                >
                  <input type="radio" name="date" readOnly={true} checked={fn_getDateTerm(rootStore).three} />
                  <span className="txt befor">지난 3일</span>
                </label>
                <label
                  onClick={event => {
                    event.preventDefault();
                    fn_setDateTerm(rootStore, "week", true);
                    fn_endOrderSearch(rootStore, "searchOld7day Button");
                  }}
                >
                  <input type="radio" name="date" readOnly={true} checked={fn_getDateTerm(rootStore).week} />
                  <span className="txt week">일주일</span>
                </label>
              </div>
            </div>
            <div className="box_search">
              <div className="tit"> • 조회설정</div>
              <div className="select">
                <button
                  type="button"
                  onClick={() =>
                    fn_setSearchView(rootStore, "key_area_view", !fn_getSearchView(rootStore).key_area_view)
                  }
                >
                  <span>{fn_getSearchKey(rootStore).val}</span>
                </button>
                <ul className={"layer " + (fn_getSearchView(rootStore).key_area_view === true ? "open" : "")}>
                  <li>
                    <button type="button" onClick={() => fn_setSearchKey(rootStore, "mobileOrderNo", "채널 주문번호")}>
                      채널 주문번호
                    </button>
                  </li>
                  <li>
                    <button type="button" onClick={() => fn_setSearchKey(rootStore, "orderNo", "포스 주문번호")}>
                      포스 주문번호
                    </button>
                  </li>
                  <li>
                    <button type="button" onClick={() => fn_setSearchKey(rootStore, "orderAmount", "주문금액")}>
                      주문금액
                    </button>
                  </li>
                </ul>
              </div>
              <div className="search">
                <input
                  type="text"
                  value={fn_getSearchVal(rootStore)}
                  onChange={event => fn_setSearchVal(rootStore, event.target.value)}
                />
                <button
                  type="button"
                  className={
                    fn_getSearchView(rootStore).detail_area_view ? "btn_detail_search on" : "btn_detail_search"
                  }
                  onClick={() => {
                    fn_setSearchView(rootStore, "detail_area_view", !fn_getSearchView(rootStore).detail_area_view);
                  }}
                >
                  <span>상세검색 {fn_getSearchView(rootStore).detail_area_view ? "닫기" : "열기"}</span>
                </button>
              </div>
            </div>
            <div
              className={"layer_detail_search " + (fn_getSearchView(rootStore).detail_area_view === true ? "open" : "")}
            >
              <div className="inner">
                <p className="txt">조건 미설정시 전체 항목으로 검색됩니다 </p>
                <dl>
                  <dt className="!pt-0">주문유형</dt>
                  <dd className="flex gap-3">
                    {orderTypeFilters.map((filter, index) => (
                      <Chip
                        key={index}
                        id={filter.id}
                        name={filter.name}
                        label={filter.label}
                        checked={fn_getDetailButtonView(rootStore)[filter.id]}
                        onClick={() =>
                          fn_setDetailButtonView(rootStore, filter.id, !fn_getDetailButtonView(rootStore)[filter.id])
                        }
                      />
                    ))}
                  </dd>
                </dl>
                <dl>
                  <dt className="!pt-0">주문채널</dt>

                  <dd className="flex flex-wrap gap-3">
                    {orderChannelFilters.map(filter => (
                      <Chip
                        key={filter.id}
                        id={filter.id}
                        name={filter.name}
                        label={filter.label}
                        checked={fn_getDetailButtonView(rootStore)[filter.id]}
                        onClick={() =>
                          fn_setDetailButtonView(rootStore, filter.id, !fn_getDetailButtonView(rootStore)[filter.id])
                        }
                      />
                    ))}
                  </dd>
                </dl>
                <dl>
                  <dt className="!pt-0">결제수단</dt>
                  <dd className="flex gap-3">
                    {paymentMethodFilters.map(filter => (
                      <Chip
                        key={filter.id}
                        id={filter.id}
                        name={filter.name}
                        label={filter.label}
                        checked={fn_getDetailButtonView(rootStore)[filter.id]}
                        onClick={() =>
                          fn_setDetailButtonView(rootStore, filter.id, !fn_getDetailButtonView(rootStore)[filter.id])
                        }
                      />
                    ))}
                  </dd>
                </dl>
                <dl>
                  <dt className="!pt-0">주문상태</dt>
                  <dd className="flex gap-3">
                    {orderStatusFilters.map(filter => (
                      <Chip
                        key={filter.id}
                        id={filter.id}
                        name={filter.name}
                        label={filter.label}
                        checked={fn_getDetailButtonView(rootStore)[filter.id]}
                        onClick={() =>
                          fn_setDetailButtonView(rootStore, filter.id, !fn_getDetailButtonView(rootStore)[filter.id])
                        }
                      />
                    ))}
                  </dd>
                </dl>
              </div>
              <div className="btns">
                <button type="button" className="reset" onClick={() => fn_initDetailButtonView(rootStore)}>
                  조건 초기화
                </button>
                <button
                  type="button"
                  className="search"
                  onClick={() => {
                    rootStore.endOrderStore.setEndOrderPagingInfo("end_page_no", 1);
                    fn_endOrderSearch(rootStore, "searchOldDetail Button");
                  }}
                >
                  검색
                </button>
              </div>
            </div>
            <div className="search_box">
              <button
                type="submit"
                className="btn_search"
                onClick={event => {
                  rootStore.endOrderStore.setEndOrderPagingInfo("end_page_no", 1);
                  fn_endOrderSearch(rootStore, "searchOldList Button");
                }}
              >
                검색
              </button>
            </div>
            <div className="close">
              <Link to="/">
                <button type="button">
                  <span className="btn_order_history_close">닫기</span>
                </button>
              </Link>
            </div>
          </div>
          <div className="wrap_table">
            <table>
              <thead>
                <tr>
                  <th>주문일시</th>
                  <th>
                    완료(취소)
                    <br />
                    시간
                  </th>
                  <th>
                    채널
                    <br />
                    주문번호
                  </th>
                  <th>
                    포스
                    <br />
                    주문번호
                  </th>
                  <th>
                    포스
                    <br />
                    영수번호
                  </th>
                  <th>유형</th>
                  <th>채널</th>
                  <th>주문자 정보</th>
                  <th>금액</th>
                  <th>결제</th>
                  <th>
                    주문
                    <br />
                    상태
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(endOrderStore.getEndOrderList) && endOrderStore.getEndOrderList.length ? (
                  endOrderStore.getEndOrderList?.map((order: any, idx: number) => (
                    <EndOrderItemView key={idx} rootStore={rootStore} order={order} />
                  ))
                ) : (
                  <tr>
                    <td colSpan={10}>
                      <b>검색 결과가 없습니다.</b>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <EndOrderPagingBottomView rootStore={rootStore} />
      </div>
    </>
  );
};

export default inject("rootStore")(observer(SettingEndOrderView));
